import { TitleColor } from '..';
import Text from '../Text';

const Education2019 = () => (
  <>
    <TitleColor text="Kurser 2019" smallTitle />
    <Text>
      <b>ClickerExpo Luminos</b>
      <br />
      Konference den 25.-27. oktober: "Aggression i hunde: Adfærdsanalyse og
      behandlingsprotokoller."
    </Text>
    <Text>
      <b>Ann-Kristin Meyer</b>
      <br />
      Foredrag den 14. april: "Hundens ernæring - Vejen ud af den store jungle af hundefoder."
    </Text>
  </>
);

export default Education2019;
